import { useCreate, useGetList, useGetListWithActivePrograms, useGetMine } from './useProfile'

export const profile = {
  getList: useGetList,
  create: useCreate,
  getListWithActivePrograms: useGetListWithActivePrograms,
  mine: useGetMine,
}
